export enum Currency {
  EUR = "EUR",
  GBP = "GBP",
}
